import React, { Component, Fragment } from 'react';
// import CollapsibleWrapper from 'js/components/global/collapsible/CollapsibleWrapper';
import Collapsible from 'js/components/global/collapsible/Collapsible';
import MenuItem from '../MenuItem';
import ResortsBlock from '../menuBlocks/ResortsBlock';
import IslandsBlock from '../menuBlocks/IslandsBlock';
import InclusionsBlock from '../menuBlocks/InclusionsBlock';
import ForEveryoneBlock from '../menuBlocks/ForEveryoneBlock';
import WeddingsBlock from '../menuBlocks/WeddingsBlock';
import SpecialsBlock from '../menuBlocks/SpecialsBlock';
import menuData from 'js/modules/menuData/index';
import {isBeaches} from 'js/modules/brand';
import {classHelper} from 'js/modules/utils';

const getBlocks = ({ menuBlocks = {}, includes = {} } = {}) => {

  const {
    resorts = [],
    islands = [],
    inclusions = [],
    weddings = {},
    specials = {},
    forEveryone = {},
  } = menuBlocks;

  const {fastLinks = []} = includes;

  const options = {
    sandals: [
      <ResortsBlock resorts={resorts} fastLinks={fastLinks} />,
      <IslandsBlock islands={islands} fastLinks={fastLinks} />,
      <InclusionsBlock inclusions={inclusions} />,
      <WeddingsBlock weddings={weddings}/>,
      <SpecialsBlock specials={specials} />,
    ],
    beaches: [
      <ResortsBlock resorts={resorts} fastLinks={fastLinks} />,
      <InclusionsBlock inclusions={inclusions} />,
      <ForEveryoneBlock forEveryone={forEveryone} />,
      <WeddingsBlock weddings={weddings} />,
      <SpecialsBlock specials={specials} />
    ]
  };

  return options[window._app.brandOptions.longName] || options.sandals;
};

const menuLinks = menuData[window._app.brandOptions.longName];
const menuBlocks = getBlocks(menuLinks);

class MainMenu extends Component {

  constructor(props) {
    super(props);

    this.isMobile = window.innerWidth < 768;

    this.state = {
      activeBlock: this.isMobile ? undefined : 0
    };
  }

  onMenuItemHover = index => {

    return () => {

      const isNotMobile = window.innerWidth > 767;

      if (isNotMobile) {
        this.setState({ activeBlock: index });
      }
    };
  };

  onMenuClick = index => event => {

    const isTouchDevice = window.innerWidth < 1164;
    const isNotMobile = window.innerWidth > 767;
    const { activeBlock } = this.state;

    if (isTouchDevice) {
      event.preventDefault();
    }

    if (isNotMobile) {
      return;
    }

    if (activeBlock === index) {
      this.setState({ activeBlock: undefined });
    } else {
      this.setState({ activeBlock: index });
    }

  };

  handleCollapsibleIcon = (collapsibleName) => {

    return () => {

      const { ...isActive } = this.state.isActive;

      isActive[collapsibleName] = !isActive[collapsibleName];

      this.setState({ isActive });
    };
  };

  renderMainLinks = () => {

    const {primaryMenu = []} = menuLinks;

    const elements = primaryMenu.map((item, index) => {

      const classes = {
        'active': this.state.activeBlock === index,
        'first-child': !index,
        'weddings': (
          item.label.indexOf('Weddings') > -1
        )
      };

      const jsxMenuItem = (
        <a className={`primary-links ${classHelper(classes)}`}
          onClick={this.onMenuClick(index)}
          onMouseOver={this.onMenuItemHover(index)}
          href={item.link}
        >
          {item.label}
          {
            item.subLabel &&
            <small className="d-sm-inline-block">{item.subLabel}</small>
          }
          {
            this.state.activeBlock === index
              ? <i className="icon-minus expand visible-md-down" />
              : <i className="icon-close-simple expand visible-md-down" />
          }
        </a>
      );


      // return (
      //   <Fragment key={item.label + index}>
      //     {
      //       this.isMobile ?
      //         <CollapsibleWrapper
      //           header={jsxMenuItem}
      //           children={menuBlocks[index]} />
      //         :
      //         jsxMenuItem
      //     }
      //   </Fragment>
      // );

      return (
        <Fragment key={item.label + index}>
          {
            this.isMobile ?
              <Collapsible
                classList={['']}
                title={jsxMenuItem}
                expanded={this.state.activeBlock === index}
                children={menuBlocks[index]} />
              :
              jsxMenuItem
          }
        </Fragment>
      );
    });

    return <div className="main-nav-list">{ elements }</div>;
  };

  _renderNavBar = () => {

    const {secondaryMenu = []} = menuLinks;
    const navbarGrid = isBeaches ? 'md-4' : 'md-6';

    return (
      <nav className={`navbar full-height sm-12 ${navbarGrid} lg-3`}>
        <div className="scrollable-lg">

          {this.renderMainLinks()}

          <ul className="secondary-nav-list">
            {
              secondaryMenu.map((item, index) => (
                <MenuItem
                  key={item.label + index}
                  link={item.link}
                  label={item.label} />
              ))
            }
          </ul>
        </div>
      </nav>
    );
  };

  render() {
    const { activeBlock } = this.state;

    this.isMobile = window.innerWidth < 768;

    return (
      <div className={`rct-mn full-height ${isBeaches ? 'rct-mn-bchs' : ''}`}>
        <div className="container full-height scroll-div">
          <div className="navbar-wrapper row full-height">
            {this._renderNavBar()}
            {!this.isMobile && menuBlocks[activeBlock]}
          </div>
        </div>
      </div>
    );
  }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./js/components/global/menu/sandals/MainMenu.js